import component from './en/component';
import globalHeader from './en/globalHeader';
import menu from './en/menu';
import pages from './en/pages';
import pwa from './en/pwa';
import settingDrawer from './en/settingDrawer';
import settings from './en/settings';
import inquiry from './en/inquiry';

export default {
	'navBar.lang': 'Languages',
	'layout.user.link.help': 'Help',
	'layout.user.link.privacy': 'Privacy',
	'layout.user.link.terms': 'Terms',
	'app.preview.down.block': 'Download this page to your local project',
	'app.welcome.link.fetch-blocks': 'Get all block',
	'app.welcome.link.block-list': 'Based on block development, quick build standard pages',
	...globalHeader,
	...menu,
	...settingDrawer,
	...settings,
	...pwa,
	...component,
	...pages,
	...inquiry
};
